import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "handover-component" }

import { StateViewModel } from '@/features/bots/models/designer';
import IslandBadge from './IslandBadge.vue';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HumanHandoverComponent',
  props: {
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const state = ref<StateViewModel>({
  id: '',
  component: 'HumanHandover',
});

watch(
  () => props.value,
  (value) => (state.value = value),
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IslandBadge, {
      type: "humanhandover",
      draggable: false
    }),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "component-contents" }, "Pause Bot", -1))
  ]))
}
}

})